import { ic } from '@/components/Icons';
import { useI18n } from '@/i18n';

export interface PaginationProps {
  page: number;
  pageCount: number;
  onPage: (p: number) => void;
  total?: number;
  /** Records per page. Pass with onPer to show the size selector. */
  per?: number;
  onPer?: (n: number) => void;
  perOptions?: number[];
}

export function Pagination({ page, pageCount, onPage, total, per, onPer, perOptions }: PaginationProps) {
  const { lang, t } = useI18n();
  const hasPer = !!(per && onPer);
  if (pageCount <= 1 && !hasPer) return null;

  const opts = (perOptions || [10, 15, 25, 50, 100]).slice();
  if (hasPer && per && !opts.includes(per)) {
    opts.push(per);
    opts.sort((a, b) => a - b);
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, marginTop: 10, fontSize: 12, color: 'var(--text-2)', flexWrap: 'wrap' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 14, flexWrap: 'wrap' }}>
        <span>{total != null ? `${total} ${lang === 'es' ? 'registros' : 'records'}` : ''}</span>
        {hasPer ? (
          <label style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <span>{lang === 'es' ? 'Mostrar' : 'Show'}</span>
            <select
              value={per}
              onChange={(e) => onPer?.(Number(e.target.value))}
              aria-label={lang === 'es' ? 'Registros por página' : 'Records per page'}
              style={{ padding: '5px 8px', borderRadius: 6, border: '1px solid var(--line-2)', fontSize: 12, background: 'var(--surface)', color: 'var(--text)', cursor: 'pointer' }}
            >
              {opts.map((n) => (
                <option key={n} value={n}>{n}</option>
              ))}
            </select>
            <span>{lang === 'es' ? 'por página' : 'per page'}</span>
          </label>
        ) : null}
      </div>
      {pageCount > 1 ? (
        <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
          <button className="btn sm" onClick={() => onPage(Math.max(1, page - 1))} disabled={page <= 1}>
            {ic.chevL} {t('common.prev')}
          </button>
          <span className="mono" style={{ padding: '0 6px' }}>{page} / {pageCount}</span>
          <button className="btn sm" onClick={() => onPage(Math.min(pageCount, page + 1))} disabled={page >= pageCount}>
            {t('common.next')} {ic.chevR}
          </button>
        </div>
      ) : null}
    </div>
  );
}
